import React from "react";
import TruncateText from "./TruncateText";
import { viewPath } from "../../utils/routeUtils";
import { Button, Paper, styled, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export interface FileTableProps {
  title: string;
  files: readonly (
    | {
        readonly file_name?: string | null | undefined;
        readonly file_url?: string | null | undefined;
        readonly id?: string;
      }
    | null
    | undefined
  )[];
}

const StyledTableCell = styled(TableCell)(() => ({
  borderBottom: "none",
}));

const StyledTable = styled(Table)(() => ({
  tableLayout: "fixed",
  wordWrap: "break-word",
}));

const StyledPaper = styled(Paper)(() => ({
  marginTop: "10px",
  marginBottom: "10px",
}));

const AlternatingRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const Title = styled(Typography)(() => ({
  padding: "10px",
}));

/**
 * Creates a table that renders files.
 * @param title the table title
 * @param files
 * @returns a react node that represents a table.
 */
const FileTable: React.FC<FileTableProps> = ({ title, files }: FileTableProps) => {
  return (
    files && (
      <StyledPaper>
        <Title>
          <strong>{title}</strong>
        </Title>
        <StyledTable stickyHeader size="small">
          <TableBody>
            {files
              ?.filter((file) => file?.id)
              .map((file, index) => {
                return (
                  <AlternatingRow key={index}>
                    <StyledTableCell style={{ width: "80%" }}>
                      <TruncateText text={file?.file_name ?? file?.id ?? ""} />
                    </StyledTableCell>
                    <StyledTableCell style={{ width: "150px" }}>
                      {file?.file_url && (
                        <Button variant="outlined" href={file.file_url}>
                          Download
                        </Button>
                      )}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: "150px" }}>
                      <Button variant="outlined" component={Link} to={viewPath(file?.id)}>
                        more
                      </Button>
                    </StyledTableCell>
                  </AlternatingRow>
                );
              })}
          </TableBody>
        </StyledTable>
      </StyledPaper>
    )
  );
};

export default FileTable;
